import { Anchor, Box, Flex, Stack, Title } from '@mantine/core'
import { faEnvelope, faPhone } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PersonWithBlueShirt from '@phoenix-web/icons-images/svgs/PersonWithBlueShirt.svg'
import PersonWithGreenJacket from '@phoenix-web/icons-images/svgs/PersonWithGreenJacket.svg'
import PersonWithOrangeShirt from '@phoenix-web/icons-images/svgs/PersonWithOrangeShirt.svg'
import PersonWithYellowSweater from '@phoenix-web/icons-images/svgs/PersonWithYellowSweater.svg'
import { formatPhone } from '@phoenix-web/utils/general'
import { SUPPORT_EMAIL, SUPPORT_PHONE } from '../../constants'
import SupportCard from './SupportCard'
import styles from './SupportPage.module.css'

const supportCardsInfo = [
  {
    cardTitle: 'Contact us',
    path: '', // empty string to disable link and the hover behavior
    image: PersonWithYellowSweater,
    imageAlt: 'Person with yellow sweater',
    imageStyling: {
      width: '96px',
      height: 'auto',
    },
    children: <ContactUsLinks />,
  },
  {
    cardTitle: 'FAQs',
    path: `/faq`,
    image: PersonWithGreenJacket,
    imageAlt: 'Person with green jacket',
    imageStyling: {
      width: '135px',
      height: 'auto',
      marginLeft: '-30px',
      marginTop: '-3px',
    },
  },
  {
    cardTitle: 'Resource Center',
    path: `/resources`,
    image: PersonWithBlueShirt,
    imageAlt: 'Person with blue shirt',
    imageStyling: {
      width: '162px',
      height: 'auto',
      marginLeft: '-15px',
      marginTop: '-5px',
    },
  },
  {
    cardTitle: 'Testimonials',
    path: `/testimonials`,
    image: PersonWithOrangeShirt,
    imageAlt: 'Person with orange shirt',
    imageStyling: {
      width: '90px',
      height: 'auto',
      marginLeft: '7px',
      marginTop: '3px',
    },
  },
]

export default function SupportPage({ frontyardUrl }: { frontyardUrl: string }) {
  return (
    <Box pl={{ base: 0, sm: 'xxl' }}>
      <Title pl={{ base: 'sm', sm: 0 }} py="xl" fz="2.25rem" fw="500" c="brand-blue.9">
        Support
      </Title>
      <Flex className={styles.supportCardsFlexBox} gap="xxl">
        {supportCardsInfo.map((cardInfo) => (
          <SupportCard
            {...cardInfo}
            href={cardInfo.path ? frontyardUrl + cardInfo.path : ''}
            key={cardInfo.cardTitle}
          />
        ))}
      </Flex>
    </Box>
  )
}

function ContactUsLinks() {
  return (
    <Stack gap="xs">
      <Anchor className={styles.chatMethod} href={`mailto:${SUPPORT_EMAIL}`}>
        <FontAwesomeIcon icon={faEnvelope} />
        {SUPPORT_EMAIL}
      </Anchor>
      <Anchor className={styles.chatMethod} href={`tel:${SUPPORT_PHONE}`}>
        <FontAwesomeIcon icon={faPhone} />
        {formatPhone(SUPPORT_PHONE)}
      </Anchor>
    </Stack>
  )
}
